import React from "react";
import { Link } from "react-router-dom";
import "../sass/main.scss"

function Main() {
  return (
    <>
      <div className="main">
        <img src="/image/배경.jpg" alt="" />
        <div className="bar"></div>
        <div className="wrap">
          <div className="content">
            <img src="/image/로고.png" alt="" />
            <h2>KUCKJAE METAL COMPANY</h2>
            <p>AGIPU System</p>
            <div className="info">
              <ul>
                <li>
                  <h3>Address</h3>
                  <p>
                    <b>- Seoul Office & Corporate research center</b>
                    <div>
                      14, Gyeongin-ro 77ga-gil, Yeongdeungpo-gu, Seoul, Repubilc of Korea
                    </div>
                    <b>- Incheon Factory</b>
                    <div>
                      52, Namdong-daero 156Beon-gil, Namdong-gu, Incheon, Republic of Korea
                    </div>
                  </p>
                </li>
                <li>
                  <h3>Tel</h3>
                  <p>82-2-2634-5886 / 82-2-2634-4167</p>
                </li>
                <li>
                  <h3>Fax</h3>
                  <p>82-2-2671-2115</p>
                </li>
                <li>
                  <h3>E-Mail</h3>
                  <p>kuckjae@naver.com</p>
                </li>
                <li>
                  <h3>Homepage</h3>
                  <p>www.Kuckjae.co.kr</p>
                </li>
                <li>
                  <h3>Promotional Video</h3>
                  <p>
                    <b>Unboxing and Cup Feeder System </b>
                    <a href="https://www.youtube.com/watch?v=A5ohCnrvyhk" target="_blank">(Go to YouTube)</a>
                  </p>
                </li>
              </ul>
              <div className="link">
                <Link to="/detail/en/COMPANY/1">
                <img src="/image/영어.png" alt="" />
                  ENGLISH
                  <i class="fas fa-chevron-right"></i>
                </Link>
                {/* <Link to="/detail/ru/Компания/1">
                <img src="/image/러시아어.png" alt="" />
                  Русский
                  <i class="fas fa-chevron-right"></i>
                </Link> */}
                <Link to="/detail/Hindi/कंपनी/1">
                <img src="/image/힌디어.png" alt="" />
                हिन्दी
                  <i class="fas fa-chevron-right"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Main;
